<template>
	<div class="head clearfix">
		<img src="../../../static/images/menu.png" class="menu" @click='showm'>
		<router-link to='/index'>
			<img src="../../../static/images/logo.png" class="logo">
		</router-link>
		<div class="search_wrap">
			<input type="text" name="" placeholder="请输入关键字" v-model='keyword' @keyup.enter='search'>
			<img src="../../../static/images/icon_search.png" class="search_btn" @click='search'>
		</div>
		<div :class="{top_menu:true,fadeInLeft:showin,animated:true,fadeOutLeft:showout}" v-show='showmenu'>
			<img src="../../../static/images/close.png" class="close" @click='closem'>
			<div class="menulist">
				<router-link to="/index">
					<div class="menu_item" @click='showmenu=false'>首&emsp;页</div>
				</router-link>
				<router-link to="/product">
					<div class="menu_item"  @click='showmenu=false'>产&emsp;品</div>
				</router-link>
				<router-link to="/leavemsg">
					<div class="menu_item"  @click='showmenu=false'>留&emsp;言</div>
				</router-link>
				<router-link to="/our">
					<div class="menu_item"  @click='showmenu=false'>我&emsp;们</div>
				</router-link>
			</div>
		</div>
	</div>
</template>
<script>
import animatecss from 'animate.css'
	export default {
	  name: 'head',
	  data(){
	  	return{
	  		showmenu:false,
	  		keyword:'',
	  		showin:false,
	  		showout:true
	  	}
	  },
	  mounted:function(){
	  	
	  },
	  watch:{
	  	
	  },
	  methods:{
	  	showm(){
	  		this.showin=!this.showin;
	  		this.showout=!this.showout
	  		this.showmenu=true
	  	},
	  	closem(){
	  		this.showmenu=true
	  		this.showin=false;
	  		this.showout=true
	  	},
	  	search:function(){
	  		if(!this.keyword){
	  			alertMessage('搜索内容不能为空')
	  			return false;
	  		}
	  		this.$router.push('/search/'+this.keyword)
	  	}
	  }
	  
	}
</script>
<style scoped>
	.head{
		height: 126px;
		background-color: #fff;
		position: relative;
		border-bottom: 1px solid #efefef;
		min-width: 1200px;
	}
	.menu{
		float: left;
		margin-left: 36px;
		margin-top: 37px;
		cursor: pointer;
	}
	.logo{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		cursor: pointer;
	}
	.search_wrap{
		float: right;
		margin-right: 36px;
		margin-top: 41px;
		background-color: #f9f9f9;
		position: relative;
	}
	.search_wrap input{
		width: 306px;
		height: 44px;
		color: #5b5b5b;
		font-size: 14px;
		padding:0 60px 0 15px; 
		box-sizing: border-box;
		background-color: #f9f9f9;
	}
	.search_btn{
		position: absolute;
		right: 18px;
		top: 50%;
		transform: translateY(-50%);
		cursor: pointer;
	}
	.top_menu{
		position: fixed;
		left: 0;
		height: 100%;
		width: 280px;
		background-color: #545c64;
		z-index: 999;
	}
	.close{
		margin-top: 48px;
		margin-left: 216px;
		cursor: pointer;
		margin-bottom: 64px;
	}
	.menu_item{
		width: 100%;
		height: 64px;
		line-height: 64px;
		text-align: center;
		font-size: 14px;
		color: #fff;
	}
	.menu_item:hover{
		background-color: #434a50;
	}
</style>


// WEBPACK FOOTER //
// src/components/public/head.vue